import React from 'react'

function Input(props) {
    return (
        <div className={`input-body ${props.className}`} style={props.style}>
            <label htmlFor={props.id}>{props.lable}</label>
            {props.required === "true"
            ? 
                <input type={props.type} name={props.name} id={props.id} value={props.value} onChange={props.onChange} maxLength={props.maxLength} minLength={props.minLength}  onInput={props.onInput} pattern={props.pattern} title={props.title} placeholder={props.placeholder} required/>
            : 
                <input type={props.type} name={props.name} id={props.id} value={props.value} onChange={props.onChange} maxLength={props.maxLength} minLength={props.minLength} onInput={props.onInput} pattern={props.pattern} title={props.title} placeholder={props.placeholder} />
            }
            {props.description && <p>{props.description}</p>}
        </div>
    )
}

function TextArea(props){
    return (
        <div className={`input-body ${props.className}`} style={props.style}>
            <label htmlFor={props.id}>{props.lable}</label>
            <textarea name={props.name} id={props.id} value={props.value} onChange={props.onChange} onInput={props.onInput}></textarea>
            {props.description && <p>{props.description}</p>}
        </div>
    )
}
export {TextArea, Input}